/** @format */

import React, {useContext, useState} from 'react';
import {capitalize} from 'frontier/ds/quoter/functions/format';
import {Button, IconButton, Input} from '@sttark/design-system';
import {QuoteContext} from 'frontier-quoter';
import {IfElse, If} from 'frontier-utilities';
import {useDesignHandler} from 'frontier/ds/quoter/hoc/use_design_handler';

import './uploaded_designs_orders.sass';
import {RenderConditionSingle} from 'frontier-admin/orders/filter_builder/render_condition_single';

const Design = props => {
    const ctx = useContext(QuoteContext);
    const [isDeleting, setIsDeleting] = useState(false);
    const designHandler = useDesignHandler(props);

    if (ctx.order.is_duplex || ctx.order.is_front_back) {
        const linkedDesign = props.designsOrders.find(({design}) => {
            return design.linked_design_id === props.design.id;
        });

        return (
            <div className="carton">
                <div className="header">
                    <h4>
                        {ctx.order.is_front_back ? 'Set' : capitalize(ctx.singularProduct)}{' '}
                        {props.index + 1}
                    </h4>

                    <Input
                        label={ctx.order.is_front_back ? 'Qty Per Item in Set' : 'Quantity'}
                        size={ctx.order.is_front_back ? '16' : '8'}
                        type="number"
                        value={
                            designHandler.designOrder.qty > 0 ? designHandler.designOrder.qty : null
                        }
                        onChange={v => designHandler.handleChangeQty(props.id, parseInt(v))}
                    />
                </div>
                <div className="divider"></div>
                <div className="design-group">
                    {linkedDesign && (
                        <div className="reorder-icon">
                            <IfElse condition={!designHandler.isSwapping}>
                                <IconButton
                                    tabIndex="-1"
                                    secondary
                                    icon="autorenew"
                                    onClick={designHandler.handleSwap}
                                />
                                <i className="fa fa-spinner fa-spin"></i>
                            </IfElse>
                        </div>
                    )}
                    <div className="single-design-container">
                        <div className="single-design">
                            <div className="label">
                                <IfElse condition={ctx.order.is_duplex}>
                                    <span>Outside design</span>
                                    <span>Front design</span>
                                </IfElse>
                            </div>
                            <div className="filename d-flex align-items-center justify-content-start gap-4">
                                <span>{props.design.customer_filename}</span>
                                <If condition={ctx.order.is_front_back}>
                                    <span style={{opacity: 6}}>
                                        (total count:{' '}
                                        {designHandler.designOrder.qty > 0
                                            ? designHandler.designOrder.qty
                                            : 0}
                                        )
                                    </span>
                                </If>
                            </div>
                            <div className="actions">
                                <IconButton
                                    tabIndex="-1"
                                    secondary
                                    icon="zoomin"
                                    onClick={() => window.open(props.signed_url)}
                                />
                            </div>
                        </div>
                        {!linkedDesign && (
                            <div className="mt-2">
                                <Button
                                    secondary
                                    label={`Upload File`}
                                    onClick={props.onClickAddFiles}></Button>
                            </div>
                        )}
                        {linkedDesign && (
                            <div className="single-design">
                                <div className="label">
                                    <IfElse condition={ctx.order.is_duplex}>
                                        <span>Inside design</span>
                                        <span>Back design</span>
                                    </IfElse>
                                </div>
                                <div className="filename  d-flex align-items-center justify-content-start gap-4">
                                    <span>{linkedDesign.design.customer_filename}</span>
                                    <If condition={ctx.order.is_front_back}>
                                        <span style={{opacity: 6}}>
                                            (total count:{' '}
                                            {designHandler.designOrder.qty > 0
                                                ? designHandler.designOrder.qty
                                                : 0}
                                            )
                                        </span>
                                    </If>
                                </div>
                                <div className="actions">
                                    <IconButton
                                        tabIndex="-1"
                                        secondary
                                        icon="zoomin"
                                        onClick={() => window.open(linkedDesign.signed_url)}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="reorder-icon">
                        <IfElse condition={isDeleting}>
                            <i className="fa fa-spinner fa-spin"></i>
                            <IconButton
                                tabIndex="-1"
                                secondary
                                icon="trash"
                                onClick={() => {
                                    setIsDeleting(true);
                                    designHandler.handleDelete();
                                }}
                            />
                        </IfElse>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="hstack">
            <Input
                label="Quantity"
                size="8"
                type="number"
                value={designHandler.designOrder.qty > 0 ? designHandler.designOrder.qty : null}
                onChange={v => designHandler.handleChangeQty(props.id, parseInt(v))}
            />
            <span className="ms-4 flex-grow-1">{props.customer_filename}</span>
            <span className="font-body-xl">
                <IconButton
                    tabIndex="-1"
                    secondary
                    icon="zoomin"
                    onClick={() => window.open(props.signed_url)}
                />
                <IfElse condition={isDeleting}>
                    <i className="fa fa-spinner fa-spin"></i>
                    <IconButton
                        tabIndex="-1"
                        secondary
                        icon="trash"
                        onClick={() => {
                            setIsDeleting(true);
                            designHandler.handleDelete();
                        }}
                    />
                </IfElse>
            </span>
        </div>
    );
};

export default Design;
